/* eslint-disable */
import { Post } from '../../Axios/AxiosFunctions';
import Button from '../../Component/Button/Button';
import Input from '../../Component/Input/Input';
import { FORM_REG_EX, FORM_REG_EX_REPLACER } from '../../data/regex';
import validator from 'validator';
import classes from './ResetPassword.module.css';
import React, { useState } from 'react';
import { BaseURL } from '../../config/apiUrl';
import { apiHeader } from '../../config/apiUrl';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Header from '../../Component/Header';
import Footer from '../../Component/Footer';
import { Container } from 'react-bootstrap';

function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const code = searchParams.get('code') || '';

  const [form, setForm] = useState({ ...DEFAULT_FORM, email, otpCode: code });
  const [loading, setLoading] = useState(false);

  // OnChange handler
  const onChange = (name, value) => {
    setForm({ ...form, [name]: value });
  };

  // Form submission handler
  const handleSubmit = async () => {
    let valid = true;

    // Check required fields
    for (let key in form) {
      if (!form[key]) {
        toast.warn(
          `Please fill the ${key.replace(FORM_REG_EX, FORM_REG_EX_REPLACER).toLowerCase()} field.`
        );
        valid = false;
      }
    }

    // Validate password length
    if (form.password.length < 8) {
      toast.warn('Password must be 8 characters long.');
      valid = false;
    }

    // Confirm passwords match
    if (form.confirmPassword !== form.password) {
      toast.warn('Password and confirmed password should match.');
      valid = false;
    }

    // Validate email
    if (!validator.isEmail(form.email)) {
      toast.warn('Please enter a valid email.');
      valid = false;
    }

    if (!valid) return;

    setLoading(true);
    try {
      const response = await Post(BaseURL('users/resetPassword'), form, apiHeader());

      if (response) {
        toast.success('Successfully reset password');
        navigate(-3);
      }
    } catch (error) {
      toast.error('Failed to reset password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Container>
        <div className={classes.mainContainer}>
          <div className={classes._main}>
            <h1>Reset Password</h1>
            <div className={classes._form}>
              <div className={classes._inputContainer}>
                <Input
                  setValue={(e) => onChange('password', e)}
                  value={form.password}
                  placeholder={'Password *'}
                  type="password"
                />
              </div>
              <div className={classes._inputContainer}>
                <Input
                  setValue={(e) => onChange('confirmPassword', e)}
                  value={form.confirmPassword}
                  placeholder={'Confirm Password *'}
                  type="password"
                />
              </div>
              <div className={classes._bottomDiv}>
                <Button
                  disabled={loading}
                  loading={loading}
                  label={loading ? 'Resetting Password...' : 'Reset Password'}
                  onClick={handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
}

export default ResetPassword;

const DEFAULT_FORM = {
  password: '',
  confirmPassword: ''
};
